import React, { Component } from 'react'
import FormComponentsMixin from 'containers/shared/FormComponentsMixin'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import {Markdown, StyledForm, TextAgreement} from 'components'
import { UserActions } from 'actionsets'
import { TokenActions } from 'actionsets'
import { DocumentActions } from 'actionsets'
import { Authorization, registeredStatuses } from 'utils/AuthorizationUtils'
import StyleSheet from 'styles'
import Dependent from 'containers/shared/Dependent'
import CenteredContent from 'containers/CenteredContent'

export class Tncs extends FormComponentsMixin(Component) {
  constructor(props) {
    super(props)
    this.state = {
      attributes: {
        id: this.props.currentUser.id,
        investorTncsAgreedAt: Authorization.investorTncsAgreed ? this.investorTncs.updatedAt : null,
        issuerTncsAgreedAt: Authorization.issuerTncsAgreed ? this.investorTncs.updatedAt : null,
      },
      errors: {}
    }
    UserActions.bindActions(this)
    TokenActions.bindActions(this, 'token')
    DocumentActions.bindActions(this, 'document')
  }

  async dependsOn() {
    const issuerTask = this.actions.document.show({name: 'issuer_tncs'})
    const investorTask = this.actions.document.show({name: 'investor_tncs'})

    await issuerTask; await investorTask
  }

  get issuerTncs() {
    return this.props.documents.issuerTncs
  }

  get investorTncs() {
    return this.props.documents.investorTncs
  }

  dependenciesMet() {
    return !!(this.issuerTncs && this.issuerTncs.renderedContent && this.investorTncs && this.investorTncs.renderedContent)
  }

  attributeChanged = attribute => event => {
    this.setAttribute(attribute, event.target.value)
  }

  setAttribute = (attribute, value) => {
    this.setState({
      attributes: {
        ...this.state.attributes,
        [attribute]: value
      }
    })
  }

  attribute = (name, defaultValue='') => {
    if(this.state.attributes[name] !== undefined)
      return this.state.attributes[name]
    return this.formObject[name] || defaultValue
  }

  get errorObject(){
    if(!this.props.errors) return {}
    const errorObject = this.props.errors.updateTncs
    return errorObject ? (errorObject.meta || {}) : {}
  }

  getErrorName = (attribute) => {
    switch (attribute) {
      case 'investorTncsAgreedAt':
        return 'investorAccount.tncsAgreedAt'
      case 'issuerTncsAgreedAt':
        return 'issuerAccount.tncsAgreedAt'
      default:
        return attribute
    }
  }

  hasError = errorName =>
    !!(this.errorObject && this.errorObject[this.getErrorName(errorName)])

  getError = errorName => {
    return ((this.errorObject && this.errorObject[this.getErrorName(errorName)]) || []).join(' ')
  }

  update = async() => {
    await this.actions.updateTncs(this.state.attributes)
    await this.actions.token.verify()
    this.props.history.push('/')
  }


  handleInvestorTncsAgreed = agreed => () => {
    this.setAttribute('investorTncsAgreedAt', agreed ? this.investorTncs.downloadedAt : false)
    this.setState({showInvestorTncs: false})
  }

  handleIssuerTncsAgreed = agreed => () => {
    this.setAttribute('issuerTncsAgreedAt', agreed ? this.issuerTncs.downloadedAt : false)
    this.setState({showIssuerTncs: false})
  }

  ensureUserHasViewedInvestorTncs = event => {
    if(!this.state.attributes.investorTncsAgreedAt){
      this.setState({showInvestorTncs: true})
      event.stopPropagation()
      event.preventDefault()
    }
  }

  ensureUserHasViewedIssuerTncs = event => {
    if(!this.state.attributes.issuerTncsAgreedAt){
      this.setState({showIssuerTncs: true})
      event.stopPropagation()
      event.preventDefault()
    }
  }

  render = () => {
    const { SwitchField } = this
    return (
      <CenteredContent>
        <StyledForm style={{maxWidth: 553}}>
          <Typography variant='h5'>Terms and Conditions</Typography>
          <div className={styles.section}>
            <Typography variant='subtitle1'>
              {/*if*/ Authorization.tncsExpired ?
                'The terms and conditions have been updated. You need to agree to them to continue using your account'
              /*else*/:
                'You need to agree to the terms and conditions to continue using your account.'
              }

            </Typography>

            {this.props.currentUser.investorStatus in registeredStatuses &&
              <SwitchField label='Terms & Conditions' attribute='investorTncsAgreedAt' onClick={this.ensureUserHasViewedInvestorTncs} />}

            {this.props.currentUser.issuerStatus in registeredStatuses &&
              <SwitchField label='Terms & Conditions for Issuers' attribute='issuerTncsAgreedAt' onClick={this.ensureUserHasViewedIssuerTncs} />}

            <TextAgreement
              title='Terms and Conditions'
              open={this.state.showInvestorTncs}
              onConfirm={this.handleInvestorTncsAgreed(true)}
              onCancel={this.handleInvestorTncsAgreed(false)}
            >
              <Markdown mdtext={this.investorTncs.renderedContent} />
            </TextAgreement>
            <TextAgreement
              title='Terms and Conditions'
              open={this.state.showIssuerTncs}
              onConfirm={this.handleIssuerTncsAgreed(true)}
              onCancel={this.handleIssuerTncsAgreed(false)}
            >
              <Markdown mdtext={this.issuerTncs.renderedContent} />
            </TextAgreement>
          </div>

          <Button variant="contained" color="primary" onClick={this.update}>Update</Button>
        </StyledForm>
      </CenteredContent>
    )
  }

}

const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    flex: 1
  },
  section: {
    marginBottom: 50,
    position: 'relative'
  },
})

export default connect(({tokens, users, documents}) => {return {...tokens, ...users, documents}})(Dependent({loader: true, wrapperClassName: styles.wrapper})(Tncs))